export default __webpack_public_path__ + "static/media/OmbattuGuddaHill.f054bd3b.jpg";